import React, { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

const WEEK_CHIP_WIDTH_CLASS = 'w-[83px] min-w-[83px]';

interface IWeekChipProps {
  label: string;
  isActive: boolean;
  canRemove: boolean;
  onSelect: () => void;
  onRemove: () => void;
}

export const WeekChip: FC<IWeekChipProps> = ({
  label,
  isActive,
  canRemove,
  onSelect,
  onRemove
}) => {
  const handleRemove = (e: React.MouseEvent): void => {
    e.stopPropagation();
    onRemove();
  };

  return (
    <button
      type="button"
      onClick={onSelect}
      className={[
        'group relative box-border flex min-h-8 shrink-0 items-stretch overflow-hidden rounded-md py-2 px-2.5 transition-colors',
        WEEK_CHIP_WIDTH_CLASS,
        isActive
          ? 'border border-indigo-600 bg-purple-50 text-indigo-600'
          : 'bg-zinc-100 text-base-primary hover:bg-purple-50 hover:text-indigo-600'
      ].join(' ')}
    >
      <span
        className={[
          'pointer-events-none absolute inset-0 z-0 flex items-center justify-center text-p-xs font-medium leading-none transition-[padding] duration-200 ease-out',
          canRemove
            ? 'group-hover:pl-4 group-focus-within:pl-4'
            : ''
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <span className="whitespace-nowrap">{label}</span>
      </span>
      {canRemove && (
        <span
          role="button"
          tabIndex={0}
          aria-label={`Remove ${label}`}
          className="absolute left-2.5 top-1/2 z-[1] inline-flex h-4 w-4 -translate-y-1/2 cursor-pointer items-center justify-start rounded opacity-0 pointer-events-none transition-opacity duration-200 ease-out group-hover:pointer-events-auto group-hover:opacity-100 group-focus-within:pointer-events-auto group-focus-within:opacity-100"
          onClick={handleRemove}
        >
          <FontAwesomeIcon
            icon="fa-regular fa-xmark"
            className="text-xs font-black text-indigo-600"
          />
        </span>
      )}
    </button>
  );
};
